import React from 'react';
import AccountSidebar from '../components/AccountSidebar';
import ReferralContent from '../components/ReferralContent';

export default function ReferralCode() {
    return (
        <div className="account-layout acc-layout-mobile">
            <div className="container">
                <div className="account-wrapper">
                    <AccountSidebar activeItem="referans-kodu" />
                    <ReferralContent />
                </div>
            </div>
        </div>
    );
}
